var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{staticClass:"toolip",attrs:{"multilined":"","label":_vm.label,"append-to-body":_vm.appendToBody}},[_c('b-icon',{attrs:{"icon":"help-circle-outline","size":"is-small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }